module.exports = __webpack_public_path__ + "static/media/ray_archuleta.e1f1b0fc.jpeg";